import React from 'react';
import { HomeExpiredWrapper } from './HomeExpiredWrapper';
import { UserContextType } from '../user/user.types';
import { withUser } from '../user/UserContext';

type Props = UserContextType;

const RawHomeExpiredWizard: React.FC<Props> = ({
  loggedIn,
  currentUser: { daysRemaining },
}) => {
  const isExpired = !!loggedIn && daysRemaining === 0;

  if (!isExpired) {
    return null;
  }
  return <HomeExpiredWrapper />;
};

export const HomeExpiredWizard = withUser(RawHomeExpiredWizard);
